// Example pages from Volym 1. Fill `src` with the real page images.
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/cf34376b-886e-4822-ab8a-072af32e6c4d/1792460583909_tk-v1-sida05-b7651f89.webp',
    label: 'Säsongsplan · Sida 5',
    title: 'Röd boll: hela säsongen i fyra block',
    text: 'En färdig säsongsplan med mål, nyckelövning, lek och minimatch för varje block – så att du alltid vet vad nästa pass ska handla om.'
  },
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/cf34376b-886e-4822-ab8a-072af32e6c4d/1792460587952_tk-v1-sida12-46011266.webp',
    label: 'Färdigt pass · Sida 12',
    title: 'Pass 1: Racketen är min kompis',
    text: 'Ett komplett nybörjarpass minut för minut med uppvärmning, lekar, bollkänsla och avslutning.'
  },
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/cf34376b-886e-4822-ab8a-072af32e6c4d/1792460591593_tk-v1-sida13-bea9a908.webp',
    label: 'Passkort · Sida 13',
    title: 'Utskrivbart passkort med banskiss',
    text: 'Hela passet på ett kort: övningar, tider, uppställning på banan och coachord att ta med ut.'
  },
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/cf34376b-886e-4822-ab8a-072af32e6c4d/1792460595689_tk-v1-sida26-8c820c9f.webp',
    label: 'Färdigt pass · Sida 26',
    title: 'Pass 8: Serve + första slag',
    text: 'Servegrund och första slaget efter serven, med progression, vanliga fel och spelformer.'
  },
  {
    src: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/cf34376b-886e-4822-ab8a-072af32e6c4d/1792460598988_tk-v1-sida37-10dfdbdf.webp',
    label: 'Nivåtest · Sida 37',
    title: 'Nivåtest grön & gul boll',
    text: 'Enkla tester med tydliga kriterier som visar var spelaren står och vad nästa steg är.'
  }
];
